module.exports = __webpack_public_path__ + "img/green.c22096d7.png";